<div class="row pl-3">
  <span class="main-header mt-3 mb-2">Tax</span>
</div>
<div class="horizontal-line mb-4 mr-2 pl-3">
  <svg xmlns="http://www.w3.org/2000/svg" width="1200" height="2" viewBox="0 0 1200 2" fill="none">
    <path
      d="M1 1H1294"
      stroke="#D7DAE0"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="2 4"
    />
  </svg>
</div>
<div class="row pl-3 pt-3">
  <div class="checkbox-with-label">
    <div class="switch ml-3">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          [checked]="isCheckedTaxFeature"
          (change)="toggleTaxFeature($event)"
        />
      </div>
    </div>
    <div class="frame-10 ml-n2">
      <div class="notification-title">Enable Tax</div>
      <div class="notification-body">Apply tax calculations to orders</div>
    </div>
  </div>
</div>

<div class="row mt-3 ml-0">
  <div class="col-md-6 col-sm-12">
    <label class="form-label1 pl-0">Tax Name:</label>
    <input type="text" class="form-control" />
  </div>
</div>

<div class="row mt-3 ml-0">
  <div class="col-md-6 col-sm-12">
    <label class="form-label1 pl-0">Tax Percentage (%) :</label>
    <input type="number" class="form-control" min="0" max="100" />
  </div>
</div>

<div class="row mt-3 ml-0">
  <div class="col-md-6 col-sm-12">
    <label class="form-label1 pl-0">Tax Type :</label>
    <div class="mt-1">
      <button
        class="btn dropdown-toggle bg-white form-control border text-left rounded-2"
        type="button"
        id="dropdownMenuButton2"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ selectedTaxType ? selectedTaxType : 'Select Tax Type' }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
        @for (taxType of taxTypes; track taxType; let i = $index) {
          <li (click)="changeTaxType(taxType)">
            <a class="dropdown-item">{{ taxType.displayName }}</a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>

<div class="row mt-3 ml-0">
  <div class="col-md-6 col-sm-12">
    <label class="form-label1 pl-0">Apply Tax On :</label>
    <div class="mt-1">
      <button
        class="btn dropdown-toggle bg-white form-control border text-left rounded-2"
        type="button"
        id="dropdownMenuButton3"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Select Item
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
        <li><a class="dropdown-item">Item 1</a></li>
        <li><a class="dropdown-item">Item 2</a></li>
        <li><a class="dropdown-item">Item 3</a></li>
      </ul>
    </div>
  </div>
</div>

<div class="horizontal-line mb-3 mr-2 pl-3 mt-3">
  <svg xmlns="http://www.w3.org/2000/svg" width="1200" height="2" viewBox="0 0 1200 2" fill="none">
    <path
      d="M1 1H1294"
      stroke="#D7DAE0"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="2 4"
    />
  </svg>
</div>

<div class="row pl-3 pt-3">
  <div class="checkbox-with-label">
    <div class="switch ml-3">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          [checked]="isShowTaxInBill"
          (change)="toggleShowTaxInBill($event)"
        />
      </div>
    </div>
    <div class="frame-10 ml-n2">
      <div class="notification-title">Show Tax On Bill</div>
      <div class="notification-body">Display tax breakdown on customer receipts</div>
    </div>
  </div>
</div>
